export const translations = {
  es: {
    meta: {
      title: "Lightning POS — Cobra en bitcoin desde tu teléfono, sin comisión por venta",
      description:
        "Convierte el teléfono que ya tienes en tu punto de venta. Cobra en bitcoin, recibe el dinero en segundos, sin contracargos y sin comprar terminal. Apúntate a la lista de espera.",
    },
    nav: {
      how: "Cómo funciona",
      features: "Qué incluye",
      pricing: "Precios",
      faq: "Preguntas",
      cta: "Apartar mi lugar",
    },
    hero: {
      badge: "Lista de espera abierta · precio de lanzamiento",
      line1: "Cobra desde el",
      line2: "teléfono que",
      line3: "ya tienes.",
      subtitle:
        "Sin comprar terminal. Sin comisión por venta. Sin computadora, sin servidor, sin instalar nada. Tu cliente escanea un código, paga con bitcoin y el dinero llega a la billetera de tu negocio en segundos.",
      ctaDemo: "Probar la demo",
      trust: "Gratis · iPhone y Android · también funciona en el navegador",
      phoneAlt:
        "Lightning POS cobrando en un teléfono: monto en pesos y código QR listo para escanear",
      phoneAmountLabel: "Total a cobrar",
      phoneShowQr: "Muéstrale este código a tu cliente",
      phoneConfirmed: "Pago recibido",
      phoneSeconds: "en segundos",
    },
    marquee: [
      "Sin comisión por venta",
      "El dinero llega en segundos",
      "Sin contracargos",
      "Sin terminal que comprar",
      "Cobras desde tu teléfono",
      "Ves tus ventas desde donde estés",
    ],
    how: {
      kicker: "Cómo funciona",
      title: "Tres pasos y estás cobrando",
      steps: [
        {
          num: "01",
          title: "Vincula tu terminal",
          text: "Escaneas un código con tu teléfono y queda listo para cobrar. Sin cables, sin técnico y sin tocar una computadora.",
          img: "/screens/vincular.svg",
          alt: "Pantalla de vinculación de terminal en Lightning POS",
        },
        {
          num: "02",
          title: "Arma el cobro",
          text: "Elige productos de tu catálogo, escanea el código de barras o escribe el monto directo. Tú decides cómo.",
          img: "/screens/carrito.svg",
          alt: "Carrito y catálogo de productos en Lightning POS",
        },
        {
          num: "03",
          title: "Tu cliente paga, tú lo ves al instante",
          text: "El cliente escanea el QR y paga. La confirmación aparece en tu pantalla al momento, y el recibo se imprime o se envía.",
          img: "/screens/cobro-qr.svg",
          alt: "Pantalla de cobro con código QR y confirmación de pago en Lightning POS",
        },
      ],
      demoTitle: "Pruébala hoy, sin cuenta y sin dinero real",
      demoText:
        "Dentro de la app, escribe demo como código de vinculación y se abre un modo de demostración completo: productos de ejemplo y cobros que se confirman solos.",
      demoCode: "demo",
      demoCta: "Probar la demo en el navegador",
    },
    features: {
      kicker: "Qué incluye",
      title: "Todo lo que tu caja necesita",
      cards: [
        { icon: "ScanBarcode", title: "Catálogo con código de barras", text: "Da de alta tus productos una vez y cóbralos con un escaneo." },
        { icon: "RefreshCw", title: "Pesos a bitcoin, en vivo", text: "El monto se convierte al tipo de cambio del momento. Tú piensas en pesos, como siempre." },
        { icon: "BadgeCheck", title: "Confirmación automática", text: "El pago se confirma solo en tu pantalla, aunque el wifi ande lento." },
        { icon: "FileText", title: "Recibos en PDF", text: "Imprímelos, compártelos o envíalos por correo." },
        { icon: "History", title: "Historial del día", text: "Tus ventas agrupadas y con detalle, para cerrar caja sin sorpresas." },
        { icon: "BarChart3", title: "Reportes de tu negocio", text: "Ve cómo va tu negocio desde donde estés." },
        { icon: "Languages", title: "Español e inglés", text: "Y tema oscuro para locales con poca luz." },
      ],
    },
    control: {
      kicker: "Tu equipo",
      title: "Tú mandas en tu caja",
      intro:
        "Dejar la caja en manos de alguien más da nervios. Por eso cada terminal obedece reglas que tú pones, desde tu propio teléfono.",
      points: [
        { icon: "Smartphone", title: "Varias terminales a la vez", text: "Cada teléfono se vincula a tu negocio con un escaneo. Barra, terraza y mostrador cobrando al mismo tiempo." },
        { icon: "UserCheck", title: "Tu cajero cobra, no administra", text: "Quien atiende la caja no ve reportes ni puede borrar ventas. Solo cobra." },
        { icon: "PowerOff", title: "Se fue un empleado, se va su terminal", text: "La desconectas desde tu teléfono, estés donde estés. Deja de cobrar en ese instante." },
        { icon: "Lock", title: "Cada terminal con su PIN", text: "Nadie cobra sin desbloquear. Punto." },
      ],
      imgAlt: "Panel de reportes y control de terminales en Lightning POS",
    },
    compare: {
      kicker: "La cuenta sale sola",
      title: "Contra la terminal de tarjeta",
      colA: "Terminal de tarjeta",
      colB: "Lightning POS",
      rows: [
        { label: "Comisión", a: "~3.5 % de cada venta", b: "mensualidad fija", win: true },
        { label: "Cuándo llega tu dinero", a: "días", b: "segundos", win: true },
        { label: "Contracargos", a: "sí", b: "no existen", win: true },
        { label: "Hardware", a: "terminal que hay que comprar", b: "el teléfono que ya tienes", win: true },
      ],
      note: "Lightning POS no reemplaza tus otras formas de cobro: las complementa para el cliente que quiere pagar con bitcoin.",
    },
    pricing: {
      title: "Precios de lanzamiento",
      subtitle:
        "Las cuentas de comercio abren pronto. Quien se apunte a la lista de espera conserva este precio.",
      recommended: "Recomendado",
      perMonth: "/mes",
      ctaFree: "Descargar la app",
      ctaPaid: "Apartar mi lugar",
      note1: "En los planes de pago: paga 10 meses, usa 12.",
      note2: "Podrás pagar en pesos o en bitcoin — tú eliges.",
      labels: {
        terminals: "Terminales",
        users: "Usuarios/cajeros",
        catalog: "Catálogo",
        history: "Historial",
        reports: "Reportes",
        emailReceipts: "Recibos por correo",
        support: "Soporte",
      },
      plans: [
        {
          id: "gratis", name: "Gratis", price: "$0", currency: "",
          terminals: "1", users: "1", catalog: "25 productos", history: "30 días",
          reports: "resumen del día", emailReceipts: false, support: "comunidad",
        },
        {
          id: "solo", name: "Solo", price: "$149", currency: "MXN",
          terminals: "1", users: "1", catalog: "ilimitado", history: "ilimitado",
          reports: "completos", emailReceipts: true, support: "correo",
        },
        {
          id: "comercio", name: "Comercio", price: "$299", currency: "MXN", featured: true,
          terminals: "3", users: "ilimitados", catalog: "ilimitado", history: "ilimitado",
          reports: "completos + exportación", emailReceipts: true, support: "correo, 48 h",
        },
        {
          id: "multi", name: "Multi-sucursal", price: "$799", currency: "MXN",
          terminals: "ilimitadas", users: "ilimitados", catalog: "ilimitado", history: "ilimitado",
          reports: "+ contable, multi-sucursal", emailReceipts: true, support: "prioritario, 24 h",
        },
      ],
    },
    form: {
      kicker: "Lista de espera",
      title: "Aparta tu lugar",
      subtitle:
        "Deja tus datos y te avisamos cuando tu cuenta de comercio esté lista. Conservas el precio de lanzamiento.",
      businessName: "Nombre del negocio",
      businessNamePh: "La Taquería de Doña Lupe",
      email: "Correo electrónico",
      emailPh: "tu@correo.com",
      whatsapp: "WhatsApp (opcional)",
      whatsappPh: "+52 55 1234 5678",
      businessType: "Tipo de negocio",
      businessTypePh: "Elige una opción",
      businessTypes: [
        { value: "cafeteria", label: "Cafetería" },
        { value: "restaurante_bar", label: "Restaurante o bar" },
        { value: "tienda", label: "Tienda" },
        { value: "hotel", label: "Hotel u hospedaje" },
        { value: "food_truck", label: "Puesto o food truck" },
        { value: "servicios", label: "Servicios" },
        { value: "otro", label: "Otro" },
      ],
      city: "Ciudad (opcional)",
      cityPh: "Ciudad de México",
      terminals: "¿Cuántas terminales necesitas?",
      terminalsPh: "Elige una opción",
      terminalOptions: [
        { value: "1", label: "1" },
        { value: "2-3", label: "2 a 3" },
        { value: "4+", label: "4 o más" },
        { value: "no_se", label: "Todavía no sé" },
      ],
      consent: "Acepto recibir avisos de Lightning POS por correo.",
      submit: "Apartar mi lugar",
      submitting: "Enviando…",
      successTitle: "¡Listo! Tu lugar está apartado.",
      successText:
        "Te escribiremos cuando las cuentas de comercio abran. Mientras tanto, puedes probar la demo hoy mismo.",
      successCta: "Probar la demo",
      errRequired: "Este campo es requerido",
      errEmail: "Escribe un correo válido",
      errConsent: "Necesitamos tu permiso para avisarte",
      errServer: "Algo salió mal. Intenta de nuevo.",
      errRate: "Demasiados intentos. Intenta más tarde.",
    },
    faq: {
      title: "Preguntas frecuentes",
      items: [
        { q: "¿Necesito saber de Bitcoin?", a: "No. Tú cobras en pesos, como siempre. La app se encarga del resto." },
        { q: "¿Necesito comprar algo?", a: "No. Funciona en el teléfono que ya tienes, iPhone o Android, y también en el navegador." },
        { q: "¿Y si mi cliente no tiene bitcoin?", a: "Lightning POS es para el cliente que sí quiere pagar así; no reemplaza tus otras formas de cobro." },
        { q: "¿Dónde queda mi dinero?", a: "Llega directo a la billetera de tu negocio. La app no lo guarda." },
        { q: "¿Cuánto tarda en llegar?", a: "Segundos." },
        { q: "¿Hay contracargos?", a: "No. Un pago confirmado es tuyo." },
        { q: "¿Puedo probarla antes?", a: "Sí. Hay una demo completa sin cuenta: ábrela en el navegador o escribe demo como código de vinculación dentro de la app." },
      ],
    },
    footer: {
      tagline: "El punto de venta que cabe en tu bolsillo.",
      download: "Descarga la app",
      appStoreAlt: "Descárgala en el App Store",
      playAlt: "Disponible en Google Play",
      webPos: "Punto de venta web",
      demo: "Demo",
      legal: "Legal",
      privacy: "Aviso de privacidad",
      dataDeletion: "Eliminación de datos",
      contact: "Contacto",
      company: "AgentykCO TM",
      rights: "Todos los derechos reservados.",
    },
    notFound: {
      title: "Esta página no existe",
      text: "El enlace que seguiste está roto o la página se movió.",
      cta: "Volver al inicio",
    },
  },

  en: {
    meta: {
      title: "Lightning POS — Accept bitcoin from your phone, no per-sale fees",
      description:
        "Turn the phone you already own into your point of sale. Accept bitcoin, get paid in seconds, no chargebacks and no terminal to buy. Join the waitlist.",
    },
    nav: {
      how: "How it works",
      features: "What's included",
      pricing: "Pricing",
      faq: "FAQ",
      cta: "Save my spot",
    },
    hero: {
      badge: "Waitlist open · launch pricing",
      line1: "Get paid with",
      line2: "the phone you",
      line3: "already own.",
      subtitle:
        "No terminal to buy. No per-sale commission. No computer, no server, nothing to install. Your customer scans a code, pays with bitcoin, and the money lands in your business wallet in seconds.",
      ctaDemo: "Try the demo",
      trust: "Free · iPhone and Android · also works in the browser",
      phoneAlt:
        "Lightning POS charging on a phone: amount in pesos and a QR code ready to scan",
      phoneAmountLabel: "Total to charge",
      phoneShowQr: "Show this code to your customer",
      phoneConfirmed: "Payment received",
      phoneSeconds: "in seconds",
    },
    marquee: [
      "No per-sale commission",
      "Money arrives in seconds",
      "No chargebacks",
      "No terminal to buy",
      "Charge from your phone",
      "See your sales from anywhere",
    ],
    how: {
      kicker: "How it works",
      title: "Three steps and you're charging",
      steps: [
        {
          num: "01",
          title: "Link your terminal",
          text: "Scan a code with your phone and it's ready to charge. No cables, no technician, no computer involved.",
          img: "/screens/vincular.svg",
          alt: "Terminal linking screen in Lightning POS",
        },
        {
          num: "02",
          title: "Build the charge",
          text: "Pick products from your catalog, scan the barcode, or type the amount directly. Your call.",
          img: "/screens/carrito.svg",
          alt: "Cart and product catalog in Lightning POS",
        },
        {
          num: "03",
          title: "Your customer pays, you see it instantly",
          text: "The customer scans the QR and pays. Confirmation shows on your screen right away, and the receipt prints or gets sent.",
          img: "/screens/cobro-qr.svg",
          alt: "Charge screen with QR code and payment confirmation in Lightning POS",
        },
      ],
      demoTitle: "Try it today — no account, no real money",
      demoText:
        "Inside the app, type demo as the linking code and a full demo mode opens: sample products and payments that confirm on their own.",
      demoCode: "demo",
      demoCta: "Try the demo in your browser",
    },
    features: {
      kicker: "What's included",
      title: "Everything your register needs",
      cards: [
        { icon: "ScanBarcode", title: "Catalog with barcodes", text: "Add your products once and charge them with a scan." },
        { icon: "RefreshCw", title: "Pesos to bitcoin, live", text: "The amount converts at the moment's exchange rate. You think in pesos, like always." },
        { icon: "BadgeCheck", title: "Automatic confirmation", text: "The payment confirms itself on your screen, even on slow wifi." },
        { icon: "FileText", title: "PDF receipts", text: "Print them, share them, or send them by email." },
        { icon: "History", title: "Daily sales history", text: "Your sales grouped and detailed, so closing the register holds no surprises." },
        { icon: "BarChart3", title: "Business reports", text: "See how your business is doing from anywhere." },
        { icon: "Languages", title: "Spanish and English", text: "Plus a dark theme for dim-lit venues." },
      ],
    },
    control: {
      kicker: "Your team",
      title: "You run your register",
      intro:
        "Handing the register to someone else is nerve-racking. That's why every terminal follows rules you set, right from your own phone.",
      points: [
        { icon: "Smartphone", title: "Several terminals at once", text: "Each phone links to your business with one scan. Bar, patio and counter charging at the same time." },
        { icon: "UserCheck", title: "Your cashier charges, doesn't manage", text: "Whoever runs the register can't see reports or delete sales. They just charge." },
        { icon: "PowerOff", title: "Employee leaves, their terminal leaves", text: "Disconnect it from your phone, wherever you are. It stops charging that instant." },
        { icon: "Lock", title: "Every terminal has its PIN", text: "Nobody charges without unlocking. Period." },
      ],
      imgAlt: "Reports panel and terminal control in Lightning POS",
    },
    compare: {
      kicker: "The math does itself",
      title: "Versus the card terminal",
      colA: "Card terminal",
      colB: "Lightning POS",
      rows: [
        { label: "Commission", a: "~3.5% of every sale", b: "flat monthly fee", win: true },
        { label: "When your money arrives", a: "days", b: "seconds", win: true },
        { label: "Chargebacks", a: "yes", b: "don't exist", win: true },
        { label: "Hardware", a: "a terminal you have to buy", b: "the phone you already own", win: true },
      ],
      note: "Lightning POS doesn't replace your other payment methods — it complements them for customers who want to pay with bitcoin.",
    },
    pricing: {
      title: "Launch pricing",
      subtitle:
        "Merchant accounts open soon. Join the waitlist and you keep this price.",
      recommended: "Recommended",
      perMonth: "/mo",
      ctaFree: "Download the app",
      ctaPaid: "Save my spot",
      note1: "On paid plans: pay for 10 months, use 12.",
      note2: "You'll be able to pay in pesos or in bitcoin — your choice.",
      labels: {
        terminals: "Terminals",
        users: "Users/cashiers",
        catalog: "Catalog",
        history: "History",
        reports: "Reports",
        emailReceipts: "Email receipts",
        support: "Support",
      },
      plans: [
        {
          id: "gratis", name: "Free", price: "$0", currency: "",
          terminals: "1", users: "1", catalog: "25 products", history: "30 days",
          reports: "daily summary", emailReceipts: false, support: "community",
        },
        {
          id: "solo", name: "Solo", price: "$149", currency: "MXN",
          terminals: "1", users: "1", catalog: "unlimited", history: "unlimited",
          reports: "full", emailReceipts: true, support: "email",
        },
        {
          id: "comercio", name: "Comercio", price: "$299", currency: "MXN", featured: true,
          terminals: "3", users: "unlimited", catalog: "unlimited", history: "unlimited",
          reports: "full + export", emailReceipts: true, support: "email, 48 h",
        },
        {
          id: "multi", name: "Multi-branch", price: "$799", currency: "MXN",
          terminals: "unlimited", users: "unlimited", catalog: "unlimited", history: "unlimited",
          reports: "+ accounting, multi-branch", emailReceipts: true, support: "priority, 24 h",
        },
      ],
    },
    form: {
      kicker: "Waitlist",
      title: "Save your spot",
      subtitle:
        "Leave your details and we'll let you know when your merchant account is ready. You keep the launch price.",
      businessName: "Business name",
      businessNamePh: "Doña Lupe's Taquería",
      email: "Email",
      emailPh: "you@email.com",
      whatsapp: "WhatsApp (optional)",
      whatsappPh: "+52 55 1234 5678",
      businessType: "Type of business",
      businessTypePh: "Pick one",
      businessTypes: [
        { value: "cafeteria", label: "Coffee shop" },
        { value: "restaurante_bar", label: "Restaurant or bar" },
        { value: "tienda", label: "Store" },
        { value: "hotel", label: "Hotel or lodging" },
        { value: "food_truck", label: "Stall or food truck" },
        { value: "servicios", label: "Services" },
        { value: "otro", label: "Other" },
      ],
      city: "City (optional)",
      cityPh: "Mexico City",
      terminals: "How many terminals do you need?",
      terminalsPh: "Pick one",
      terminalOptions: [
        { value: "1", label: "1" },
        { value: "2-3", label: "2 to 3" },
        { value: "4+", label: "4 or more" },
        { value: "no_se", label: "Not sure yet" },
      ],
      consent: "I agree to receive updates from Lightning POS by email.",
      submit: "Save my spot",
      submitting: "Sending…",
      successTitle: "Done! Your spot is saved.",
      successText:
        "We'll write to you when merchant accounts open. In the meantime, you can try the demo today.",
      successCta: "Try the demo",
      errRequired: "This field is required",
      errEmail: "Enter a valid email",
      errConsent: "We need your permission to contact you",
      errServer: "Something went wrong. Try again.",
      errRate: "Too many attempts. Try again later.",
    },
    faq: {
      title: "Frequently asked questions",
      items: [
        { q: "Do I need to know about Bitcoin?", a: "No. You charge in pesos, like always. The app handles the rest." },
        { q: "Do I need to buy anything?", a: "No. It runs on the phone you already own, iPhone or Android, and also in the browser." },
        { q: "What if my customer doesn't have bitcoin?", a: "Lightning POS is for the customer who does want to pay that way; it doesn't replace your other payment methods." },
        { q: "Where does my money go?", a: "Straight to your business wallet. The app never holds it." },
        { q: "How long until it arrives?", a: "Seconds." },
        { q: "Are there chargebacks?", a: "No. A confirmed payment is yours." },
        { q: "Can I try it first?", a: "Yes. There's a full demo with no account: open it in the browser or type demo as the linking code inside the app." },
      ],
    },
    footer: {
      tagline: "The point of sale that fits in your pocket.",
      download: "Get the app",
      appStoreAlt: "Download on the App Store",
      playAlt: "Get it on Google Play",
      webPos: "Web point of sale",
      demo: "Demo",
      legal: "Legal",
      privacy: "Privacy notice",
      dataDeletion: "Data deletion",
      contact: "Contact",
      company: "AgentykCO TM",
      rights: "All rights reserved.",
    },
    notFound: {
      title: "This page doesn't exist",
      text: "The link you followed is broken or the page moved.",
      cta: "Back to home",
    },
  },
};

export const LINKS = {
  appStore: "https://apps.apple.com/app/lightning-pos/id6790569225",
  googlePlay: "https://play.google.com/store/apps/details?id=tf.lightningnetwork.pos",
  demo: "https://pos.lightningnetwork.tf/demo",
  webPos: "https://pos.lightningnetwork.tf",
  privacy: "https://lightningnetwork.tf/privacy",
  dataDeletion: "https://lightningnetwork.tf/data-deletion",
  email: "hola@lightningnetwork.tf",
};
